module.exports = __webpack_public_path__ + "static/media/Argos.e21f262a.svg";